import { TextInput } from "@mantine/core";
import classes from "./fieldInput.module.css";

type Props =
  | {
      formProps: any;
      label: string;
      editing: boolean;
      value?: undefined;
    }
  | {
      formProps?: undefined;
      label: string;
      editing?: undefined;
      value: string | null | undefined;
    };

export default function FieldTextValue({
  editing,
  formProps,
  value,
  label,
}: Props) {
  return (
    <TextInput
      label={label}
      disabled={!editing}
      size="md"
      variant="default"
      {...formProps}
      classNames={{ input: classes.input, label: classes.label }}
      value={value ? value : formProps.value}
    />
  );
}

export const useInputStyles = () => ({ classes });
